
import React, { useCallback, useContext, useMemo, useState } from "react";
import { expenseJobOrderColumns } from "./dailyJobDialogColumns";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { Box, IconButton, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { AddCircleRounded } from "resource/muiImport";
import ExpenseJobOrderDialogV2 from "pages/Menu3/AddJobOrderExpenseV2/ExpenseJobOrderDialogV2";
import { expenseJobOrderApiNm } from "constants/expenseJobOrderConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { alertConfirmDelete, alertWarning } from "components/Alert";

let selectedExpJobOrdId = null;
let expJobOrdData = {}

const XJOCComponent = ({ xjoDataTable, onPettyCashFinish, jobOrdId }) => {

  const { ax } = useContext(GlobalStateContext);
  const [dialogExpenseJobOrderOpen, setDialogExpenseJobOrderOpen] = useState(false);

  const xjoDataTableFiltered = useMemo(() => {
    // return xjoDataTable
    return xjoDataTable.filter(xjo => xjo.IsFromOpr)
  }, [xjoDataTable])

  const handleAddExpenseJobOrder = useCallback(() => {
    const foundInvId = xjoDataTable.find(xjo => xjo.InvId)
    if(foundInvId) {
      alertWarning("ใบงานนี้มีการออกใบแจ้งหนี้แล้ว กรุณาแจ้งทีมบัญชีเพื่อทำการออกใบแจ้งหนี้เพิ่ม")
    }
    selectedExpJobOrdId = null;
    expJobOrdData = null;
    setDialogExpenseJobOrderOpen(true);
  }, [xjoDataTable])

  const handleXJOCellClick = useCallback(({row, field}) => {
    if(field === "ShowDetail") {
      selectedExpJobOrdId = row.ExpJobOrdId;
      expJobOrdData = row;
      setDialogExpenseJobOrderOpen(true);
    }
  }, [])

  const onXJODialogFinish = useCallback( async (data) => {
    if (data) {
      console.log("data", data);
      // const jobOrdIds = joSelection.length > 0? joSelection: [data.JobOrdId]
      if (data.ExpJobOrdId > 0) {
        if (data.IsDel && data.ExpJobOrdId) {
          alertConfirmDelete( async ()=>{
            const value = await ax.post(expenseJobOrderApiNm.deleteExpenseJobOrder, { ExpJobOrdIds: [data.ExpJobOrdId] })
            if(value.data) {
              onPettyCashFinish()
            }
          })
        } else {
          const postdata = {
            ...data,
            ExpJobOrdIds: [data.ExpJobOrdId],
            getArgs: { ExpJobOrdId: data.ExpJobOrdId }
          }
          const value = await ax.post(expenseJobOrderApiNm.updateExpenseJobOrderBulk, postdata)
          if (value.data) {
            onPettyCashFinish()
          }
        }
      } else {
        data.IsFromOpr = 1;
        data.JobOrdId = jobOrdId
        ax.post(expenseJobOrderApiNm.insertExpenseJobOrder, data).then((value) => {
          if(value.data){
            onPettyCashFinish()
          }
        })
      }

    }
  }, [ax, onPettyCashFinish, jobOrdId])
  return (
    <BoxFC flex={1.2} sx={{ gap: 0, mb: 0.5 }}>
      <BoxFR>
        <Typography fontWeight="bold">รายได้</Typography>
        <IconButton sx={{ p: 0 }} onClick={handleAddExpenseJobOrder}>
          <AddCircleRounded color="primary" />
        </IconButton>
      </BoxFR>
      <Box flex={1}>
        <DataGridCellExpand
          density="compact"
          hideFooter
          hideToolbar
          rows={xjoDataTableFiltered}
          columns={expenseJobOrderColumns}
          onCellClick={handleXJOCellClick}
        />
      </Box>

      <ExpenseJobOrderDialogV2
        dialogOpen={dialogExpenseJobOrderOpen}
        selectedExpJobOrdId={selectedExpJobOrdId}
        setDialogOpen={setDialogExpenseJobOrderOpen}
        onFinish={onXJODialogFinish}
        expJobOrdData={expJobOrdData}
      />
    </BoxFC>
  )
}

export default React.memo(XJOCComponent);